import { useTracking } from 'react-tracking';
import { useMount } from '@simplywallst/ui-core';
import loadable from '@loadable/component';
import { useFlag } from '@/features/unleash';
import { NewPortfolioPage } from './NewPortfolioPage';

/**
 * @deprecated Move to 'NewPortfolioPage'
 */
const DeprecatedPortfolioNew = loadable(
  () => import('./DeprecatedNewPortfolio'),
  { resolveComponent: (c) => c.DeprecatedNewPortfolio }
);

export const NewPortfolio = () => {
  const { Track, trackEvent } = useTracking({ type: 'track', subject: 'page' });
  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  const flag = useFlag({ name: 'mono-portfolio-new-page' });

  if (!flag.flagsReady) return;

  return (
    <Track>
      {flag.variant.name === 'variant' ? (
        <NewPortfolioPage />
      ) : (
        <DeprecatedPortfolioNew />
      )}
    </Track>
  );
};
